import { createGlobalStyle } from "styled-components";

/* Only what base.css cannot cover: the @font-face declarations pointing at
   public/fonts, and the app shell's own layout. Element defaults — heading
   sizes and margins, the prose measure, link colours, the focus ring — come
   from the design system's base.css, vendored into tokens.css. Do NOT restate
   them here: that paraphrase is exactly what lost the heading margins and the
   measure the last time round. */
export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "Carlito";
    src: url("/fonts/Carlito-Regular.ttf") format("truetype");
    font-style: normal;
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: "Carlito";
    src: url("/fonts/Carlito-Bold.ttf") format("truetype");
    font-style: normal;
    font-weight: 700;
    font-display: swap;
  }
  @font-face {
    font-family: "Carlito";
    src: url("/fonts/Carlito-Italic.ttf") format("truetype");
    font-style: italic;
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: "Carlito";
    src: url("/fonts/Carlito-BoldItalic.ttf") format("truetype");
    font-style: italic;
    font-weight: 700;
    font-display: swap;
  }

  html, body, #root { height: 100%; margin: 0; }

  #root { display: flex; flex-direction: column; min-height: 100vh; }

  body { overflow-x: hidden; text-wrap: pretty; }
`;
